export default __webpack_public_path__ + "images/68bc525653a6e7b2873c1f83dfd233a5-vancouver_mobile.webp";